export const ACTIONS = {
  UPDATE_APP_DATA: 'UPDATE_APP_DATA',
  UPDATE_STEPPER_INFO: 'UPDATE_STEPPER_INFO',
};
